import { current } from "@reduxjs/toolkit";
import { isAccountant, isAdmin } from "src/Common/function";
import api from "./api";

const getAll = (branch) => {
  let currentUser = UserService.getCurrentUser();
  let branchId = branch;
  if (!isAdmin()) {
    branchId = currentUser.branches[0].id;
  }
  return api.get("/api/user/getAll", { params: { branchId } });
};

const getAllUsers = (branch, roleName) => {
  let currentUser = UserService.getCurrentUser();
  let branchId = branch;
  if (!isAdmin() && !isAccountant()) {
    branchId = currentUser.branches[0].id;
  }
  let params = { branchId };
  if (roleName) {
    params["role"] = roleName;
  }
  return api.get("/api/user/getAll", {
    params: params,
  });
};

const deleteUser = (id) => {
  return api.post("/api/user/delete", { userId: id });
};

const restoreUser = (id) => {
  return api.post("/api/user/restore", { userId: id });
};

const updateUsers = (userData) => {
  return api.post("/api/user/update_users", { user_data: userData });
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

const saveCurrentUser = (user) => {
  localStorage.setItem("user", JSON.stringify(user));
};

const updateUser = (user) => {
  return api.post("/api/user/update_user", { user });
};

const updateUserPartial = (userId, fields) => {
  return api.post("/api/user/update", { userId, fields });
};

const uploadAvatar = (file, id) => {
  const formData = new FormData();
  formData.append("id", id);
  formData.append("file", file);

  return api.post("/api/user/file", formData, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });
};

const getUser = (userId) => {
  return api.get("/api/user/get-a-user-by-id", { params: { userId } });
};

const getUsers = (ids) => {
  return api.post("/api/user/get_users", { ids });
};
const getUsersByRole = (role, branch) => {
  return api.get("/api/user/getusersbyrole", { params: { role, branchId: branch.id } });
};

const getUsersByRoleWithBranchId = (role, branchId) => {
  return api.get("/api/user/getusersbyrole", { params: { role, branchId } });
};

const generateExcelForTeamManage = (branch) => {
  return api.get("/api/user/generate_excel_for_team_manage", { params: { branch } });
};

const downloadExcelForTeamManage = (branch) => {
  return api.get("/api/user/download_excel_for_team_manage", { params: { branchId: branch.id } });
};

const UserService = {
  getAll,
  getAllUsers,
  deleteUser,
  restoreUser,
  updateUsers,
  getCurrentUser,
  uploadAvatar,
  saveCurrentUser,
  updateUser,
  updateUserPartial,
  getUsers,
  getUser,
  getUsersByRole,
  getUsersByRoleWithBranchId,
  generateExcelForTeamManage,
  downloadExcelForTeamManage,
};

export default UserService;
